import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KingBedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"king_bed"}/>
}
